export default "__VITE_ASSET__xJ6f8IPv__"